import React, {useEffect} from "react";
import { connect } from "react-redux";

import LookCanvasContext from "../../../lookCanvasContext";
import LookWizardContentTitle from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentTitle";
import LookWizardContentDescription from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentDescription";
import LookWizardContentCanvas from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentCanvas";
import GroheWizardContentFeature from "./groheWizardContentFeature";
import {
  getCurrentGroups, getCurrentWizardNavItems,
  getFeatureGroupFromWizardGroup, getNextWizardStepQuantity, useHideItemsDisabledfeatureGroups
} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardShowFeatureSection
} from "../../../../../actions/wizardFunctions";
import LookWizardContentFinalPrice from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentFinalPrice";
import GroheWizardSelectedSteps from "./groheWizardSelectedSteps";
import GroheWizardContentSingleFeature from "./groheWizardContentSingleFeature";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";

const GroheWizardContent = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardShowFeatureSection, isMobile,
    setWizardShowFeatureSection, setWizardSelectedValues, setGroheActiveFeatureQuantity, visualizersLoadedLength,
    wizardSqftCartItems, setWizardActiveStep} = props;

  useHideItemsDisabledfeatureGroups(wizardActiveItem, visualizersLoadedLength, wizardSelectedValues);

  useEffect(() => {
    if (wizardShowFeatureSection) {
      setWizardShowFeatureSection(false);
    }

    if (wizardActiveStep > -1) {
      const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

      setGroheActiveFeatureQuantity(getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep, null, wizardSqftCartItems));

      if (currentGroups.length === 1 && !wizardSelectedValues[wizardActiveStep]) {
        const wizardGroup = currentGroups[0];
        const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
        if (!featureGroup) {
          return
        }

        const navItems = getCurrentWizardNavItems(wizardSelectedValues, wizardActiveStep, wizardActiveItem, wizardGroup, featureGroup);

        // console.log("wizardGroup", wizardGroup);
        if (!navItems.length && featureGroup.getRealFeaturesReceivedProperty()) {
          setWizardSelectedValues({
            [wizardActiveStep]: {
              wizardGroup,
            }
          });
          setWizardActiveStep(wizardActiveStep + 1); // skip this wizard step
        } else if (wizardGroup.useIncluded && Array.isArray(wizardGroup.featuresIncluded) && (wizardGroup.featuresIncluded.length === 1)) {
          if (navItems.length === 1) {
            console.log("setWizardSelectedValues auto feature", navItems[0]);
            setWizardSelectedValues({
              [wizardActiveStep]: {
                wizardGroup,
                selectedFeature: navItems[0].part,
                partId: featureGroup.partId,
                singleFeature: true
              }
            });
            setGroheActiveFeatureQuantity(getNextWizardStepQuantity(currentGroups, wizardSelectedValues, wizardActiveStep, navItems[0].part, wizardSqftCartItems));
          }
        } else if (wizardSqftCartItems && wizardSqftCartItems.length) {
          const selectedInSqft = wizardSqftCartItems.filter(cItem => {
            return cItem.cartFeature && cItem.cartFeature.dbFeature.groupName === (featureGroup.dbName || featureGroup.partName)
          });
          if (selectedInSqft.length) {
            const canSelectNavItem = navItems.find(navItem => {
              return selectedInSqft.some(cItem => {
                return cItem.cartFeature
                  && (cItem.cartFeature.dbFeature.sharedFeatureName === navItem.part.dbFeature.sharedFeatureName)
              })
            });
            console.log("selectedInSqft navItem", canSelectNavItem);
            if (canSelectNavItem) {
              setWizardSelectedValues({
                [wizardActiveStep]: {
                  wizardGroup,
                  selectedFeature: canSelectNavItem.part,
                  partId: featureGroup.partId,
                }
              });
            }
          }
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardActiveStep])

  let showFinalPrice = false;

  if (wizardActiveStep > -1) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (currentGroups.length === 1) {
      const featureGroup = getFeatureGroupFromWizardGroup(currentGroups[0]);
      if (wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature) {
        if (currentGroups[0].title && wizardSelectedValues[wizardActiveStep].singleFeature) {
          return <GroheWizardContentSingleFeature feature={wizardSelectedValues[wizardActiveStep].selectedFeature}
                                                  wizardGroup={currentGroups[0]}/>
        }
        return <GroheWizardContentFeature feature={wizardSelectedValues[wizardActiveStep].selectedFeature}
                                          wizardGroup={currentGroups[0]}/>
      } else if (featureGroup && featureGroup.activeFeature && !currentGroups[0].title) {
        return <GroheWizardContentFeature feature={featureGroup.activeFeature}
                                          wizardGroup={currentGroups[0]}/>
      }
    } else if (isMobile && !currentGroups.length && wizardActiveStep > -1) {
      showFinalPrice = true;
    }
  }

  return (
    <div className={isMobile ? "" : "grohe-wizard__main"}>
      <h2 className="grohe-section__title grohe-section__title--full grohe-section__title--wizard">
        <LookWizardContentTitle/>
      </h2>
      <p className="grohe-section__description grohe-section__description--full grohe-section__description--wizard">
        <LookWizardContentDescription/>
      </p>
      {showFinalPrice ? (
        <div className="grohe-wizard__final">
          <LookWizardContentFinalPrice/>
          <GroheWizardSelectedSteps isMobile={false}/>
        </div>
      ) : (
        <LookCanvasContext.Consumer>
          {(imageCanvas) => (
            <LookWizardContentCanvas imageCanvas={imageCanvas}/>
          )}
        </LookCanvasContext.Consumer>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardShowFeatureSection, wizardSqftCartItems}
    = store.wizardState;
  const {isMobile, visualizersLoaded} = store.serverState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    wizardShowFeatureSection,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
    wizardSqftCartItems,
  };
};

const mapDispatchToProps = {
  setWizardShowFeatureSection,
  setWizardSelectedValues,
  setGroheActiveFeatureQuantity,
  setWizardActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheWizardContent)
